// components/ui/Popover.js
import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../utils/helpers";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export const PopoverContent = React.forwardRef((props, ref) => {
  const { className, align = "center", sideOffset = 4, ...rest } = props;

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 rounded-md border bg-white p-4 text-black shadow-md outline-none",
          className
        )}
        {...rest}
      />
    </PopoverPrimitive.Portal>
  );
});
